<template>
  <div>
    <div
      :class="{'head':true,'show':showState,'animated1 infinite slideInDown':inState,'animated1 infinite slideOutUp':outState,}"
    >
      <div class="head-content">
        <ul id="head-nav">
          <li
            v-for="(item,index) in routeArr"
            :class="{'active':item.value===activeIndex}"
            :key="index"
          >
            <span class="span" @click="toPage(item.value,item.path)">
              {{item.name}}
              <i v-if="item.type === 'applications' || item.type === 'teaching'" class="i1 el-icon-arrow-down"></i>
            </span>
            <div class="item-list" v-if="item.type === 'applications'">
              <div class="item-li" @click="toPage2('proceduring')">过程化教学</div>
              <div class="item-li" @click="toPage2('competition')">大型赛事</div>
            </div>
            <div class="item-list" v-if="item.type === 'teaching'">
              <div class="item-li" @click="toPage3('subject')">课题立项</div>
              <div class="item-li" @click="toPage3('thesis')">论文发表</div>
            </div>
          </li>
        </ul>
        <div class="head-btn">
          <button @click="toPage1()">登录</button>
          <el-popover
            placement="bottom-end"
            width="220"
            trigger="hover"
            popper-class="head-popover"
          >
            <p>如需注册</p>
            <p>请联系高老师 15315145064</p>
            <button slot="reference" class="head-button">注册</button>
          </el-popover>
        </div>
      </div>
    </div>
    <!-- <button class="top" v-if="topState" @click="toTop()">
      <p><i class="el-icon-arrow-up"></i></p>
      <p>TOP</p>
    </button>-->
  </div>
</template>

<script>
import { bus } from '@/router/index'
import { manageUrl } from '@/api/common'
export default {
  name: 'myHeader',
  data () {
    return {
      manageUrl,
      activeIndex: 'home',
      routeArr: [
        {
          name: '首页',
          path: '/',
          value: 'home'
        },
        {
          name: '核心团队',
          path: '/team',
          value: 'team'
        },
        {
          name: '应用案例',
          path: '/applications',
          type: 'applications',
          value: 'applications'
        },
        {
          name: '教学成果',
          path: '/teaching',
          type: 'teaching',
          value: 'teaching'
        },
        {
          name: '合作模式',
          path: '/cooperation',
          value: 'cooperation'
        },
        {
          name: '创始人介绍',
          path: '/founder',
          value: 'founder'
        }
      ],
      scrolled: false,
      showState: false,
      inState: false,
      outState: false,
      topState: false,
      scrollY: 0
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.handleScroll)
    this.activeIndex = this.getIndex(this.$route.path)
  },
  beforeDestroy () {
    // window.removeEventListener('scroll', this.handleScroll)
  },
  // 监听路由地址地变化，用于监测用户的头像改变和审核状态的改变
  watch: {
    $route: 'toTop'
  },
  methods: {
    /**
     * 根据页面位置动态显示导航
     * @function handleScroll
     */
    handleScroll () {
      if (window.scrollY - this.scrollY < 0) {
        this.inState = true
        this.outState = false
      }
      if (window.scrollY > 750) {
        this.topState = true
      } else {
        this.topState = false
      }
      this.scrollY = window.scrollY
      this.scrolled = window.scrollY > 0
      this.showState = window.scrollY > 10
    },
    /**
     * 路由跳转
     * @function toPage
     * @param {Number} index 跳转页面显示内容对应的索引值
     * @param {String} path 路由地址
     */
    toPage (index, path) {
      document.documentElement.scrollTop = document.body.scrollTop = 0
      if (path === '/products') {
        localStorage.setItem('products', '')
        bus.$emit('productsPage')
      }
      this.$set(this, 'activeIndex', index)
      this.$router.replace({ path: path })
    },
    /**
     * 打开新窗口
     * @function toPage1
     */
    toPage1 () {
      window.location.href = this.manageUrl
    },
    toPage2 (type) {
      this.activeIndex = 'applications'
      localStorage.setItem('applications', type)
      if (this.$route.path !== '/applications') this.$router.push({ path: '/applications' })
      this.toTop()
      bus.$emit('applicationsPage')
    },
    toPage3 (type) {
      this.activeIndex = 'teaching'
      localStorage.setItem('teaching', type)
      if (this.$route.path !== '/teaching') this.$router.push({ path: '/teaching' })
      this.toTop()
      bus.$emit('teachingPage')
    },
    /**
     * 回到页面顶部
     * @function toTop
     */
    toTop () {
      this.activeIndex = this.getIndex(this.$route.path)
      let pageIndex = JSON.parse(sessionStorage.getItem('pageIndex'))
      if (pageIndex) {
        sessionStorage.clear()
      } else {
        document.documentElement.scrollTop = document.body.scrollTop = 0
      }
    },
    /**
     * 路由切换
     * @function getIndex
     * @param {String} path 路由地址
     * @return {Number}
     */
    getIndex (path) {
      let index = this.routeArr.findIndex(item => item.path === path)
      console.log(index)
      if (index > -1) {
        return this.routeArr[index].value
      }
      return ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less" scoped>
.head {
  height: 64px;
  min-width: 1200px;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
  background-color: #161819;
}
.head-content {
  width: 1200px;
  height: 64px;
  text-align: left;
  display: inline-block;
  vertical-align: top;
  font-size: 0;
  position: relative;
  ul {
    height: 64px;
    display: inline-block;
    vertical-align: top;
    padding-left: 150px;
    li {
      display: inline-block;
      text-align: center;
      height: 64px;
      line-height: 64px;
      font-size: 14px;
      padding: 0 20px;
      color: #FFFFFF;
      font-family: SourceHanSansSC-Medium;
      margin-right: 10px;
      cursor: pointer;
      position: relative;
      .span{
        width: 100%;
        height: 64px;
        display: inline-block;
        font-family: SourceHanSansSC-Medium;
      }
      .i1 {
        font-size: 16px;
        margin-left: 6px;
      }
      .item-list {
        position: absolute;
        width: 120px;
        background: #FFFFFF;
        min-height: 120px;
        box-shadow: 0 10px 32px 0 rgba(38,38,38,0.18);
        border-radius: 4px;
        padding-top: 10px;
        transition: all 0.5s ease;
        overflow: hidden;
        transform: translateY(50px);
        opacity: 0;
        visibility: hidden;
      }
      .item-li {
        padding-left: 16px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-weight: 400;
        font-family: SourceHanSansSC-Regular;
        color: #262626;
        text-align: left;
        position: relative;
      }
      .item-li:hover {
        color: #0C59EF;
      }
    }
    li:hover {
      color: #0C59EF ;
      .item-list {
        transform: translateY(0);
        opacity: 1;
        visibility: visible;
      }
    }
    .active {
      color: #0C59EF ;
    }
  }
  .head-btn {
    height: 64px;
    padding-top: 14px;
    display: inline-block;
    position: absolute;
    right: 0;
    top: 0;
    button {
      font-size: 14px;
      width: 68px;
      height: 36px;
      color: #fff;
      background: none;
      cursor: pointer;
      margin-left: 10px;
      display: inline-block;
      vertical-align: middle;
    }
    .head-button {
      border: 1px solid #FFFFFF;
      border-radius: 4px;
    }
    .default {
      border: 1px solid #ffffff;
    }
    .head-button:focus {
      border: 1px solid #ffffff;
      background-color: #ffffff;
      color: #0C59EF;
    }
    .head-button:hover {
      border: 1px solid #ffffff;
      background-color: #ffffff;
      color: #0C59EF;
    }
  }
}
.top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 40;
  opacity: 0.8;
  color: #fff;
  background-color: #2a5298;
  padding: 2px 10px;
  cursor: pointer;
  i {
    font-size: 24px;
  }
}
</style>
<style lang="less">
.head-popover {
  padding: 24px 22px;
  font-size: 14px;
  color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/components/myHeader.vue